/* eslint-disabled */

export default class TagExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
